import { useEffect, useState } from "react";
const getAssetUrl = (assets, locale, assetLink) => {
    if (!assetLink)
        return "";
    const asset = assets[assetLink.sys.id];
    return asset?.fields.file[locale]?.url
        ? `https:${asset.fields.file[locale].url}`
        : "";
};
const useGetContentfulEntry = (id, environment, contentType, token, space) => {
    const [fields, setFields] = useState(null);
    const [assets, setAssets] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://cdn.contentful.com/spaces/${space}/environments/${environment}/entries/?` +
                    new URLSearchParams({
                        "sys.id": id,
                        content_type: contentType,
                        locale: "*",
                    }), {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (!response.ok) {
                    throw new Error("Failed to fetch entity data");
                }
                const data = await response.json();
                if (!data.items || data.items.length === 0) {
                    throw new Error("No entity found with the specified ID");
                }
                const assetsMap = (data.includes.Asset ?? []).reduce((acc, asset) => {
                    acc[asset.sys.id] = asset;
                    return acc;
                }, {});
                setAssets(assetsMap);
                setFields(data.items[0].fields);
            }
            catch (err) {
                setError(err instanceof Error ? err.message : "An error occurred");
            }
            finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [id, environment, token, space]);
    return { fields, assets, isLoading, error };
};
export { useGetContentfulEntry, getAssetUrl };
//# sourceMappingURL=contentful.js.map